/* eslint-disable one-var */
(function () {
  'use strict';

  class VehicleSettingsCtrl {
    constructor($safetyService, Authenticator, FeaturehubJsSdk, FeatureHubConfigKeys, Keys, ServiceVfiltro, FactoryVfiltro, $state) {
      this.safetyService = $safetyService;
      this.authenticator = Authenticator;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.state = $state;
      this.user = {};
      this.isFeatureFlagVehicleSettingsPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.VEHICLE_SETTINGS_PAGE);

      this.authenticator.getUser()
        .then(user => {
          this.user = user;

          ServiceVfiltro.init(FactoryVfiltro.get([
            {
              key: this.keys.uo.name
            }
          ]))
          .then((filtro) => {
            this.filtro = filtro;
            this.initializePage(this.serviceVfiltro.getFiltroBackendNovo(this.filtro));
          });
        });
    }

    initializePage(filter) {
      this.safetyService.initialize()
      .then(() => this.loadPage(filter));
    }

    goToProfile(profileId) {
      this.state.go('root.vehicleSettingsProfile', {profileId});
    }

    loadPage(filter) {
      const appName = 'safetyApp',
          componentPath = './VehicleSettingsPage',
          componentId = 'safety-app-vehicle-settings',
          props = {
            user: this.user,
            filter: filter,
            goToProfile: (profileId) => this.goToProfile(profileId)
          };

      if (this.isFeatureFlagVehicleSettingsPageEnabled) {
        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }
  }
  VehicleSettingsCtrl.$inject = ['safetyService', 'Authenticator', 'FeaturehubJsSdk', 'FeatureHubConfigKeys', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$state'];
  angular
    .module('vehicleSettings')
    .controller('VehicleSettingsCtrl', VehicleSettingsCtrl);
}());
